import React, { useState } from 'react'

import styled from '@emotion/styled'
import { BrowserUtils } from '../../utils/siteUtils'

import { highlightBlueDark10, white, fontFamilyOpenSans } from '../../constants/principles'
import { getNavFooterTheme } from '../../constants/themes'
import { FlexDiv } from '../generic/Basics'
import { SummaryPageNumber, ContactPageNumber, LoadingPageNumber, breakpoints, ExteriorPageNumber } from '../../constants'
import NoDamageIndicationModal from '../condition/NoDamageIndicationModal'
import { pageObject } from '../../constants/pageObject'

export default ({ nextClick, backClick, nextDisabled, nextStep, step, urlState, backStep, experienceState, offer, globalState, addImpressions, tab, errors, offerError, updateGlobalState = v => v }) => {
  step = step || 1
  const { isAdmin, shouldShowOfferCreationComponent, theme } = experienceState
  const { reviewReached } = globalState
  const offerReady = !!reviewReached || (offer && !offer.quickQuote)
  let answered = false
  const [showModal, setShowModal] = useState(false)
  // Get theme configuration
  const themeConfig = getNavFooterTheme({ theme, shouldShowOfferCreationComponent })

  function FindQC(urlState, text) {
    var index, key, hasValue, keys
    keys = Object.keys(urlState)
    for (index = 0; index < keys.length; ++index) {
      key = keys[index]
      if (key.substring(0, 3) === text || key === 'qp/65') {
        if (key === 'qp/65') {
          hasValue = Object.keys(urlState[key]).length && urlState[key].v !== 1
        } else {
          hasValue = Object.keys(urlState[key]).length
        }
        if (hasValue > 0) {
          answered = true
        }
      }
    }
    return answered
  }

  const closeModal = () => {
    setShowModal(false)
  }

  const modalNextStep = data => {
    setShowModal(false)
    nextClick(data)
  }

  const flipFlags = () => {
    setShowModal(true)
    fireAnalyticsDelayed('continue_modal', { cp: pageObject[tab] })
    setYesItPerfectModalPosition()
  }

  const fireAnalyticsDelayed = (event, extraData = {}, delay = 500) => {
    setTimeout(updateGlobalState, delay, { fireAnalytics: event, ...extraData })
  }

  const setYesItPerfectModalPosition = () => {
    try {
      if (BrowserUtils.isMobile() && BrowserUtils.isIframe()) {
        var btnNext = document.querySelectorAll("[data-testid='nav-bt-next']")[0]
        var noDamageModal = document.querySelectorAll("[data-testid='vc-no-damage-modal']")[0]
        noDamageModal.parentElement.style.position = 'absolute'
        noDamageModal.parentElement.style.top = btnNext.getBoundingClientRect().top - noDamageModal.offsetHeight + btnNext.offsetHeight + 'px'
        var bgCover = noDamageModal.closest('#bgModalDiv')
        bgCover.addEventListener('click', function (e) {
          noDamageModal.parentElement.style.top = e.clientY + 'px'
        })
      }
    } catch (error) {
      console.log(error)
    }
  }

  const rightButtonClick = (step, isReview = false) => {
    isReview && updateGlobalState({ resetTrim: true, hasShownMisMatchPopup: true })
    globalState.origValuesContact && updateGlobalState({ origValuesContact: undefined })
    globalState.origValuesDealerRep && updateGlobalState({ origValuesDealerRep: undefined })
    globalState.origResetTrim && updateGlobalState({ origResetTrim: undefined })
    step === LoadingPageNumber && fireAnalyticsDelayed('summary_submit_offer')

    nextClick(step)
  }

  // Use theme-based button colors from theme configuration
  const leftButtonColors = themeConfig.leftButtonColors
  const rightButtonColors = themeConfig.rightButtonColors

  let rightButton2 = null
  let rightButton = ['Next', 82, rightButtonColors[0], rightButtonColors[1], () => rightButtonClick(nextStep)]

  if (step === SummaryPageNumber || (!isAdmin && step === ContactPageNumber)) {
    rightButton = [(offer ? 'Update' : 'Get') + ' My Offer', 173, rightButtonColors[2], rightButtonColors[3], () => rightButtonClick(LoadingPageNumber)]
  } else if (step === ContactPageNumber && !offerReady) {
    rightButton = ['Review', 173, rightButtonColors[2], rightButtonColors[3], () => rightButtonClick(SummaryPageNumber, true)]
  } else if (isAdmin && offerReady) {
    rightButton = ['Save', 62, rightButtonColors[0], rightButtonColors[1], () => rightButtonClick(SummaryPageNumber)]
    rightButton2 = ['Save & Next', 132, rightButtonColors[0], rightButtonColors[1], () => rightButtonClick(nextStep)]
  } else if (urlState !== undefined && step === ExteriorPageNumber && !FindQC(urlState, 'qc/') && globalState.showNoDamageModal) {
    rightButton = ['Next', 82, rightButtonColors[0], rightButtonColors[1], () => flipFlags()]
  }

  let leftButton2 = null
  let leftButton = ['Back', leftButtonColors[0], leftButtonColors[1], leftButtonColors[2], () => backClick(backStep)]

  if (offerReady && isAdmin) {
    if (step === SummaryPageNumber) {
      leftButton = [undefined, undefined, undefined, undefined, undefined]
    } else {
      leftButton = [
        'Cancel',
        leftButtonColors[0],
        leftButtonColors[1],
        leftButtonColors[2],
        () => {
          globalState.origValuesContact && updateGlobalState(globalState.origValuesContact)
          globalState.origValuesDealerRep && updateGlobalState(globalState.origValuesDealerRep)
          globalState.origResetTrim && updateGlobalState(globalState.origResetTrim)
          return BrowserUtils.navigateToReviewInit(globalState.historyState || {})
        }
      ]
    }
  }

  return (
    <>
      <SpaceDiv />
      <StyledBackgroundDiv id="NavFooter" themeConfig={themeConfig}>
        <StyledSpacerDiv>
          {leftButton2 && (
            <StyledNextButton textColor={leftButton2[1]} backgroundColor={leftButton2[2]} borderColor={leftButton2[3]} onClick={leftButton2[4]} fontWeight={'600'} themeConfig={themeConfig}>
              {leftButton2[0]}
            </StyledNextButton>
          )}
          <StyledNextButton textColor={leftButton[1]} backgroundColor={leftButton[2]} borderColor={leftButton[3]} onClick={leftButton[4]} fontWeight={'600'} data-testid={'nav-bt-back'} themeConfig={themeConfig}>
            {leftButton[0]}
          </StyledNextButton>
          <div style={{ flex: 1 }}></div>
          <NoDamageIndicationModal
            showModal={showModal}
            nextClick={modalNextStep}
            onCloseModal={closeModal}
            addImpressions={addImpressions}
            updateGlobalState={updateGlobalState}
            tab={tab}
            urlState={urlState}
            shouldShowOfferCreationComponent={shouldShowOfferCreationComponent}
            theme={theme}></NoDamageIndicationModal>
          <StyledNextButton
            disabled={nextDisabled}
            width={rightButton[1]}
            borderColor={themeConfig?.borderColor || rightButton[2]} //
            textColor={rightButton[3]}
            backgroundColor={rightButton[2]}
            onClick={nextDisabled ? undefined : rightButton[4]}
            fontWeight={'800'}
            data-testid={'nav-bt-next'}
            themeConfig={themeConfig}>
            {rightButton[0]}
          </StyledNextButton>
          {rightButton2 && (
            <StyledNextButton
              disabled={nextDisabled}
              width={rightButton2[1]}
              borderColor={rightButton2[2]} //
              textColor={rightButton2[3]}
              backgroundColor={rightButton2[2]}
              onClick={nextDisabled ? undefined : rightButton2[4]}
              fontWeight={'800'}
              themeConfig={themeConfig}>
              {rightButton2[0]}
            </StyledNextButton>
          )}
        </StyledSpacerDiv>
      </StyledBackgroundDiv>
    </>
  )
}

const SpaceDiv = styled.div`
  display: flex;
  flex-direction: row;
  flex-grow: 1;
`
const StyledBackgroundDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 83px;
  width: 100%;
  background-color: ${p => p.themeConfig.backgroundColor};
`
const StyledSpacerDiv = styled.div`
  display: flex;
  width: 100%;
  @media (min-width: ${breakpoints.lg}px) {
    width: 1024px;
  }
  justify-content: space-between;
`

const StyledNextButton = styled(FlexDiv)`
  font-family: ${p => p.themeConfig?.fontFamily || fontFamilyOpenSans};
  font-weight: ${p => p.themeConfig?.fontWeight || p.fontWeight};
  font-size: ${p => p.themeConfig?.fontSize || 16}px;
  @media (min-width: ${breakpoints.lg}px) {
    font-size: 18px;
  }
  line-height: 24px;
  text-align: center;
  color: ${p => p.textColor};
  background-color: ${p => p.backgroundColor};
  width: ${p => p.themeConfig?.width || p.width || 82}px;
  height: ${p => p.themeConfig?.buttonHeight || 40}px;
  border: ${p => p.themeConfig?.borderWidth || '1px'} solid ${p => (p.borderColor ? p.borderColor : p.onClick ? white : '#0057b5')};
  border-radius: ${p => p.themeConfig?.borderRadius || '4px'};
  margin: 0px 6px;
  ${p => (p.themeConfig?.transition ? `transition: ${p.themeConfig.transition};` : '')};
  ${p => (p.themeConfig?.padding ? `padding: ${p.themeConfig.padding};` : '')};
  ${p => (p.themeConfig?.textTransform ? `text-transform: ${p.themeConfig.textTransform};` : '')};
  ${p =>
    p.themeConfig?.hoverShadow
      ? `
    &:hover {
    box-shadow: ${p.themeConfig.hoverShadow};
    }`
      : ''}
  ${p =>
    p.disabled
      ? `
    opacity: ${p.themeConfig?.rightButtonDisabled?.opacity || 1};
    color: ${p.themeConfig?.rightButtonDisabled?.color || ''};
    background-color: ${p.themeConfig?.rightButtonDisabled?.backgroundColor || ''};
    border: ${p.themeConfig?.borderWidth || '0px'} solid ${p.themeConfig?.rightButtonDisabled?.borderColor || p.borderColor ? p.borderColor : p.onClick ? white : '#0057b5'};
    &:hover {
      box-shadow: none;
    }
  `
      : `
    color: ${p => p.textColor};
    cursor: pointer;
  `}
`
